import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { SubSink } from 'subsink';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { LegalCounselService } from 'src/app/acl-data/legal-counsel/legal-counsel.service';
import { LegalCounsel } from 'src/app/acl-data/legal-counsel/legal-counsel.dto';

@Component({
  selector: 'app-legal-counsel-list',
  templateUrl: './legal-counsel-list.component.html',
  styleUrls: ['./legal-counsel-list.component.scss']
})
export class LegalCounselListComponent implements OnInit, OnDestroy {
  subSink = new SubSink();
  legalCounsels;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  loading$ = this.legalCounselService.loading$;
  dataSource;

  displayedColumns: string[] = [
      'fullname',
      'email',
      'active',
  ];

  constructor(
      private router: Router,
      private legalCounselService: LegalCounselService,
      private dialog: MatDialog
  ) {}

  ngOnDestroy(): void {
      this.subSink.unsubscribe();
  }

  ngOnInit(): void {
      this.subSink.add(
          this.legalCounselService
              .getAll()
              .pipe(
                  map(v =>
                      v.sort((a, b) => (a["fullname"].toLowerCase() > b["fullname"].toLowerCase() ? 1 : -1))
                  )
              )
              .subscribe(v => {
                  this.legalCounsels = v;
                  if (this.legalCounsels && this.legalCounsels.length > 0) {
                      this.dataSource = new MatTableDataSource<LegalCounsel>(
                          this.legalCounsels
                      );

                      this.dataSource.paginator = this.paginator;
                      this.dataSource.sort = this.sort;
                      console.log(this.sort);
                  }
              })
      );
  }

  applyFilter(filterValue: string) {
      this.dataSource.filter = filterValue.trim().toLowerCase();

      if (this.dataSource.paginator) {
          this.dataSource.paginator.firstPage();
      }
  }

}
